// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"ae55cb22","65":"4eae455e","152":"47e6d211","166":"729b1c6b","626":"94f24abd","787":"7ff3e3ca","811":"3b970597"}[chunkId] + ".chunk.js";
};